import React from 'react';
import { useHistory } from 'react-router-dom';
import { useAppDispatch } from 'flow/hooks/useRedux';
import { segmentTrack } from 'flow/actions/segment-actions';
import Icon from 'flow/components/ui-components/Icon';
import IconButton from 'flow/components/ui-components/IconButton';
import { useModal } from 'flow/contexts/ModalProvider';
import useAppContext from 'flow/hooks/useAppContext';
import { TicketKey } from 'flow/types/EntityKeys';
import { routes } from 'flow/types/routes';
import { generatePath } from 'flow/utils/router-utils';
import { TICKET_STRINGS } from 'flow/utils/segment-utils';

interface Props {
    ticketKey: TicketKey;
    segmentContext?: string;
}

const GoToTicketsButton = ({ ticketKey, segmentContext }: Props) => {
    const { i18next } = useAppContext();
    const history = useHistory();
    const dispatch = useAppDispatch();
    const { closeModal } = useModal();

    const handleClick = () => {
        dispatch(
            segmentTrack(TICKET_STRINGS.CLICK_GO_TO_TICKET, {
                component: segmentContext,
            }),
        );
        history.push(generatePath(routes['tickets.ticketKey'], { ticketKey }));
        closeModal();
    };

    const label = i18next.t('tickets.go_to');

    return (
        <IconButton
            tooltipLabel={label}
            aria-label={label}
            onClick={handleClick}
            className="flex size-10 items-center justify-center rounded-lg bg-gray-200 text-gray-600"
        >
            <Icon iconKey="openInNew" />
        </IconButton>
    );
};

export default GoToTicketsButton;
